import { render, staticRenderFns } from "./SpinnerColor.vue?vue&type=template&id=187a0b4e&"
import script from "./SpinnerColor.vue?vue&type=script&lang=js&"
export * from "./SpinnerColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports